import { SystemRole, type LoggedInUser, type TFSEntry, type TFSEntryMetadata } from "@/models"
import { useAppConfig } from "@/stores/configStore"
import { Duration, Now } from "@/temporal"

export function isTFSActiveOrUpcoming(tfs: TFSEntryMetadata | TFSEntry) {
	const config = useAppConfig()
	const now = Now.plainDateISO()

	if (tfs.closed) {
		return false
	}

	const upcomingDuration = Duration.from({ days: config.tfsUpcomingDaysBefore })
	const upcomingValidFrom = tfs.validFrom?.subtract(upcomingDuration) ?? null

	if (upcomingValidFrom && now.isBefore(upcomingValidFrom)) {
		return false
	}
	if (tfs.validTo && now.isAfter(tfs.validTo)) {
		return false
	}
	return true
}

export function isTFSActive(tfs: TFSEntryMetadata | TFSEntry) {
	const now = Now.plainDateISO()
	if (tfs.validFrom && now.isBefore(tfs.validFrom)) {
		return false
	}
	if (tfs.validTo && now.isAfter(tfs.validTo)) {
		return false
	}
	return !tfs.closed
}

export function canEditAnyTFSField(tfs: TFSEntryMetadata | TFSEntry | null, loggedInUser: LoggedInUser) {
	if (!loggedInUser.atLeastHasRole(SystemRole.Administrator)) {
		return false
	}
	if (!tfs) {
		return true
	}
	if (tfs.closed) {
		return false
	}
	if (tfs.consentIssued !== null && tfs.validTo && Now.plainDateISO().isAfter(tfs.validTo)) {
		return false
	}
	return true
}
